/**
 * Available payment types
 */
const paymentTypes = [
    { id: 1, name: "Sepa Lastschriftmandat", addition: 0 },
    { id: 2, name: "Überweisung", addition: 0 },
];

export default paymentTypes;
